import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-button-submit',
    templateUrl: './a-button-submit.component.html',
    styleUrls: ['./a-button-submit.component.scss'],
    // tslint:disable-next-line:no-host-metadata-property
})
export class AButtonSubmitComponent implements OnInit {

    // Expanded host binding
    @HostBinding('class._expanded') isExpanded: boolean = false;

    @Input()
    public labelKey: string;

    @Input()
    public loading: false;

    @Input()
    public expanded: boolean = false;

    @Input()
    public disabled: boolean = false;

    ngOnInit(): void {
        if (this.expanded) {
            this.isExpanded = true;
        }
    }
}
